<template>
  <v-flex text-center>
    <v-flex text-right pr-5 pt-2>
            <v-btn
        transparent
        icon @click="$router.push('/product')"
      >
        <v-icon white--text> add </v-icon>
      </v-btn>
      <v-btn
        text icon
        v-bind:class="[ isSearch ? 'white' : 'transparent' ]"
        @click="isSearch = !isSearch; search = ''"
      >
        <v-icon v-bind:class="[ isSearch ? 'black--text' : 'white--text' ]">
          search
        </v-icon>
      </v-btn>
    </v-flex>
    <v-layout row>
      <v-flex
        offset-sm2 xs12 sm8
        v-if="isSearch"
      >
        <v-text-field
          :label="$t('global.search')"
          append-icon="search"
          color=grey filled light
          background-color="white"
          v-model="search"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-flex>
          <h1>{{$t('products.yourProducts')}} ({{ filteredList.length }}/{{products.length}}) </h1>
          <ProductsIconsList
            :products=filteredList
            v-on:reload="reloadProducts()"
          />
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from 'axios'
import ProductsIconsList from './ProductsIconsList.vue'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl
var instance = axios.create({
  headers: { 'Authorization': 'Bearer ' + localStorage.token }
})
export default {
  components: {
    ProductsIconsList
  },
  data () {
    return {
      'products': [],
      isSearch: true,
      ageRanges: ['Under 25', '25 - 34', '45 - 54', '55 - 64', 'Over 65'],
      concernRange: ['none', 'low', 'medium', 'high'],
      search: '',
      errors: [],
      concerns: []
    }
  },
  methods: {
    reloadProducts () {
      instance.get('/' + this.$session.get('brand') + '/products')
        .then(response => {
          this.products = response.data.data[0].products
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    filteredList () {
      return this.products.filter(products => {
        return products.title['en-US'].toLowerCase().includes(this.search.toLowerCase()) || products.subtitle['en-US'].toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  created () {
    instance.get('/' + this.$session.get('brand') + '/products')
      .then(response => {
        this.products = response.data.data[0].products
      })
      .catch(() => {
        this.$router.push('/error')
      })
    instance.get('/' + this.$session.get('brand') + '/concerns')
      .then(response => {
        this.concerns = response.data.data[0].concerns
        this.concerns.forEach((element) => {
          element.name = element.name['en-US']
        })
      })
      .catch(() => this.$router.push('/error'))
  }
}
</script>
<style>

</style>
